var exports = {
  "k": "xfd349460--c2a032--container",
};

module.exports = exports;
